{
  "version": 1,
  "asset_id": "f1462d3e-e7eb-4e05-80f8-bce48211a0cc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f1462d3e-e7eb-4e05-80f8-bce48211a0cc/bypass-revision-completed-pouch-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f1462d3e-e7eb-4e05-80f8-bce48211a0cc/bypass-revision-completed-pouch-es-1200.webp",
  "original_filename": "bypass-revision-completed-pouch-es-1200.webp",
  "size": 61260,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:44Z"
}
